




























































































import { Vue, Component, Prop, Mixins, Ref } from "vue-property-decorator";
import FileUploader from "@/components/FileUploader.vue";
import Page from "@/views/Page.vue";
import CompanyFamiliesMixin from "@/mixins/http/CompanyFamiliesMixin";
import { RegisterHttp } from "@/utils/Decorators";
import RequestData from "@/store/types/RequestData";
import { CompanyFamily } from "@/models";
import ProductList from "@/components/Product/List.vue";
import Truncate from "@/filters/Truncate";
import Percent from "@/filters/Percent";

import Attachment from "../../models/Attachment";
import { httpStore, currentUserStore } from "@/store/typed";
import MarkupModal from "@/components/CompanyFamily/MarkupModal.vue";
import { showToast } from "../../utils/RailsRoutes";
import { showErrorToast } from "../../utils/Toast";
import AuthorizationMixin from "@/mixins/AuthorizationMixin";
import { Product } from "../../models";

@Component({
  components: { Page, FileUploader, ProductList, MarkupModal },
  filters: { Truncate, Percent },
})
export default class CompanyFamilyShow extends Mixins(
  CompanyFamiliesMixin,
  AuthorizationMixin
) {
  private companyFamily: CompanyFamily = null;
  @Ref("markupModal") readonly markupModal!: MarkupModal;
  @Ref("productList") readonly productList!: ProductList;

  static readonly getCompanyFamilytag = "get_company_family_tag";
  @RegisterHttp(CompanyFamilyShow.getCompanyFamilytag)
  getCompanyFamilyRequest!: RequestData;

  static readonly updateCompanyFamilytag = "update_company_family_tag";
  @RegisterHttp(CompanyFamilyShow.updateCompanyFamilytag)
  updateCompanyFamilyRequest!: RequestData;

  get currentUser() {
    return currentUserStore.user;
  }

  get company() {
    return this.currentUser.company;
  }

  get companyFamilyPolicy() {
    return this.authPolicy.companyFamilies;
  }

  get canUpdateMarkup() {
    return this.companyFamilyPolicy.updateMarkup;
  }

  get canEdit() {
    return this.companyFamilyPolicy.update;
  }

  get canEditFamilyProducts() {
    return this.authPolicyByAction(Product.type.toLowerCase(), "update");
  }

  async onMarkupChanged(markup: number) {
    await this.update({ markup });
    this.productList.loadProducts();
  }

  async update(payload) {
    payload = { ...payload, id: this.companyFamily.id, include: "family.*,*" };
    try {
      this.companyFamily = await this.updateCompanyFamilyMarkup(
        payload,
        CompanyFamilyShow.updateCompanyFamilytag
      );
      showToast("Family updated successfully!");
    } catch (e) {
      showErrorToast("An error occurred while updating");
    }
  }

  openMarkupModal() {
    (this.markupModal as any).setMarkup(this.companyFamily.markup);
  }

  get family() {
    return this.companyFamily?.family;
  }

  download(attachment: Attachment) {
    const url = attachment.url;
    let a = document.createElement("a");
    a.href = url;
    const fileName = url.split("/").pop();
    a.download = attachment.name;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  get description() {
    return this.family.descriptionIt;
  }

  mounted() {
    this.loadCompanyFamily();
  }

  loadCompanyFamily() {
    this.getCompanyFamily(
      this.$route.params.id,
      CompanyFamilyShow.getCompanyFamilytag
    ).then(
      (resp) => {
        this.companyFamily = resp;
      },
      (err) => {}
    );
  }

  updatePayload() {
    let payload = new FormData();
    for (const key of ["name", "code", "descriptionIt", "descriptionEn"]) {
      payload.append(key, this.family[key]);
    }

    return payload;
  }
}
